/**
 * @generated SignedSource<<8c181764a281403a0512c41320c77d36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InvitationCreateInput = {
  add_all_people_to_projects_permission: boolean;
  email: string;
  fin_permission: string;
  manage_account_permission: boolean;
  manage_people_ids?: ReadonlyArray<number | null | undefined> | null | undefined;
  manage_people_permission: string;
  manage_project_ids?: ReadonlyArray<number | null | undefined> | null | undefined;
  manage_projects_permission: string;
  user_type: string;
  view_planner_permission: boolean;
};
export type InvitationCreateMutation$variables = {
  input: InvitationCreateInput;
};
export type InvitationCreateMutation$data = {
  readonly action_invitation_create: {
    readonly account: {
      readonly id: number;
      readonly invitations: ReadonlyArray<{
        readonly email: string;
        readonly id: number;
      }>;
      readonly people: ReadonlyArray<{
        readonly id: number;
      }>;
    } | null | undefined;
    readonly error: string | null | undefined;
    readonly invitation: {
      readonly account_id: number;
      readonly add_all_people_to_projects_permission: boolean;
      readonly created_at: string;
      readonly email: string;
      readonly expires_at: any;
      readonly fin_permission: string;
      readonly id: number;
      readonly manage_account_permission: boolean;
      readonly manage_people_permission: string;
      readonly manage_projects_permission: string;
      readonly manageable_people_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly manageable_projects_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly user_type: string;
      readonly view_planner_permission: boolean;
    } | null | undefined;
  };
};
export type InvitationCreateMutation = {
  response: InvitationCreateMutation$data;
  variables: InvitationCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InvitationCreateOutput",
    "kind": "LinkedField",
    "name": "action_invitation_create",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "invitations",
        "kind": "LinkedField",
        "name": "invitation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "account_id",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "user_type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fin_permission",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "manage_projects_permission",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "manage_people_permission",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "add_all_people_to_projects_permission",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "manage_account_permission",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "view_planner_permission",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created_at",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expires_at",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "invitation_project_managers_aggregate",
            "kind": "LinkedField",
            "name": "manageable_projects_aggregate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "invitation_project_managers_aggregate_fields",
                "kind": "LinkedField",
                "name": "aggregate",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "invitation_people_managers_aggregate",
            "kind": "LinkedField",
            "name": "manageable_people_aggregate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "invitation_people_managers_aggregate_fields",
                "kind": "LinkedField",
                "name": "aggregate",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "people",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "invitations",
            "kind": "LinkedField",
            "name": "invitations",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvitationCreateMutation",
    "selections": (v4/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvitationCreateMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "54bfd501b3484590177db24a5bdbc3a0",
    "id": null,
    "metadata": {},
    "name": "InvitationCreateMutation",
    "operationKind": "mutation",
    "text": "mutation InvitationCreateMutation(\n  $input: InvitationCreateInput!\n) {\n  action_invitation_create(input: $input) {\n    invitation {\n      id\n      account_id\n      email\n      user_type\n      fin_permission\n      manage_projects_permission\n      manage_people_permission\n      add_all_people_to_projects_permission\n      manage_account_permission\n      view_planner_permission\n      created_at\n      expires_at\n      manageable_projects_aggregate {\n        aggregate {\n          count\n        }\n      }\n      manageable_people_aggregate {\n        aggregate {\n          count\n        }\n      }\n    }\n    account {\n      id\n      people {\n        id\n      }\n      invitations {\n        id\n        email\n      }\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "9ef5fef6a68a83e3bbb081e715d8c947";

export default node;
